export const getNotificationNumber = (v: number): string => {
  return v > 9 ? `${9}+` : `${v}`;
};
